/* eslint-disable react-hooks/exhaustive-deps */
import { Font } from "@react-pdf/renderer";
import { useState } from 'react';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Rudaw from '../../../../assets/fonts/rudawregular2.ttf';
import PostService from '../../../../services/postService';
import { useCompany } from '../../../../provider/companyProvider';
import { wrap } from 'comlink';
import JsBarcode from "jsbarcode";
import QRCode from 'qrcode';
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";

const worker = new Worker(new URL('./pdfMultiplePostsWorker.js', import.meta.url));
const workerApi = wrap(worker);

const registerFont = () => {
  Font.register({
    family: 'Rudaw',
    fonts: [{ src: Rudaw, fontWeight: 'normal' }],
  });
};


const PdfDriverPostList = ({ filters }) => {
  const { i18n, t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { business } = useCompany();

  const generateBarcode = (text) => {
    const canvas = document.createElement("canvas");
    JsBarcode(canvas, text, { format: "CODE128", displayValue: false });
    return canvas.toDataURL("image/png");
  };

  const handlePrint = async () => {
    registerFont();
    setIsLoading(true);

    try {
      // Fetch data
      const data = await PostService.fetchAll(filters);
      // Generate QR code for each post
      const postsWithQr = await Promise.all(
        data.map(async (post) => {
          const qrCodeImage = await QRCode.toDataURL(post.id.toString()); // or any data
          return {
            ...post,
            qrCodeImage, // attach QR image to post
            barcodeImage: generateBarcode(post.id)
          };
        })
      );

      const translations = {
        id: t('id'),
        driver: t('driver'),
        address: t('address'),
        receiverName: t('receiverName'),
        receiverPhone: t('receiverPhoneTable'),
        postType: t('postType'),
        totalPrice: t('totalPrice'),
        supervisor: t('supervisor'),
        note: t('note'),
        pageName: t('pageName'),
        pagePhone: t('pagePhone'),
      };

      // Generate PDF
      const blobUrl = await workerApi.renderPDF({
        business,
        posts: postsWithQr,
        t: translations,
        language: i18n.language,
      });
      window.open(blobUrl);
    } catch (error) {
      console.error("Error generating PDF in worker:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return isLoading
    ? <CircularProgress size={20} />
    : <PictureAsPdfOutlinedIcon sx={{ cursor: 'pointer' }} fontSize='small' onClick={handlePrint} />;
};

export default PdfDriverPostList;